import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['loyerInput', 'chargesInput', 'honorairesInput', 'fraisInput', 'total'];

  static values = {
    dg: Number,
    loyer: Number,
    charges: Number,
    honoraires: Number,
    frais: Number,
    credit: Number,
    cancelledAvoirs: Number,
  };

  autoFillAmounts() {
    this.loyerInputTarget.value = this.loyerValue;
    this.chargesInputTarget.value = this.chargesValue;
    this.honorairesInputTarget.value = this.honorairesValue;
    this.fraisInputTarget.value = this.fraisValue;
    this.updateTotalWithValues();
  }

  updateTotalWithValues() {
    let total = parseFloat(this.dgValue) + parseFloat(this.creditValue) - parseFloat(this.cancelledAvoirsValue);
    const inputs = [this.loyerInputTarget, this.chargesInputTarget, this.honorairesInputTarget, this.fraisInputTarget]
    inputs.forEach(inputElem => {
      let inputValue = parseFloat(inputElem.value);
      if (isNaN(inputValue))
        inputValue = 0.0;
      total += inputValue;
    });
    this.totalTarget.textContent = total.toFixed(2);
  }
}
